import TablesMixin from '@/mixins/TablesMixin';
import moment from 'moment-timezone';
import {draw, generate} from 'patternomaly';

export default{
    data() {
        return {
			pageLoading: false,
			loadingText: "Loading...",
			dialogFormVisible: false,
			dialogForm2Visible:false,
			pageTitle: '',
			pageSubtitle: '',
			saveChanges: false,
			saveEvent: '',
			newEvent: '',
			exitEvent: '',
			refreshListEvent: '',
			closeDialogEvent: '',
			gotoNew: false,
			gotoList: false,
			deleteEvent: '',
			showDelete: false,
			required: 'danger-text font-weight-700 font-size-18',
			backgroundColor: [
				'rgba(54,73,93,.5)',
				draw('square', '#1f77b4'),
				draw('circle', '#ff7f0e'),
				draw('diamond', '#2ca02c'),
				draw('zigzag-horizontal', '#17becf'),
				draw('triangle', 'rgb(255, 99, 132, 0.4)') // with opacity
			],
			backgroundColor2: [
				'rgba(220,20,60,.2)', // Blue
				'rgba(255,223,0,.5)',
				'rgba(54,73,93,.5)',
				'rgba(204,255,255,.5)',
				'rgba(54,73,93,.5)',
				'rgba(54,73,93,.5)',
				'rgba(54,73,93,.5)',
				'rgba(54,73,93,.5)'
			],
			borderColor: [
				'#36495d',
				'#36495d',
				'#36495d',
				'#36495d',
				'#36495d',
				'#36495d',
				'#36495d',
				'#36495d'
			],
			timeframes: [ { label: 'Minute(s)', value: 'Minute' },
            { label: 'Hour(s)', value: 'Hour' },
            { label: 'Day(s)', value: 'Day' },
            { label: 'Week(s)', value: 'Weeks' },
            { label: 'Month(s)', value: 'Month' },
            { label: 'Year(s)', value: 'Year' } ]
        };
    },
    methods: {
		handlePageSizeChanged(pageSize){
			this.paginationInfo.pageSize = pageSize;
			this.refreshTableData();
		},
		handleClose() {
			let self = this;
			if(this.saveChanges){
				this.$confirm('Do you want to save changes?')
				.then(()=> {
					self.$emit(self.saveEvent);
					self.saveChanges = false;
				})
				.catch(()=> self.closeDialog());
			}
			else{
				this.closeDialog();
			}
		},
		closeDialog() {
			this.saveChanges = false;
			this.dialogFormVisible = false;
			this.dialogForm2Visible=false;
			this.untrackChanges();
			if(this.closeDialogEvent)
				this.$emit(this.closeDialogEvent);
		},
		handleNew() {
			let self = this;
			if(this.saveChanges){
				this.$confirm('Do you want to save the current changes first?', 'Confirm', {
					distinguishCancelAndClose: true,
					confirmButtonText: 'Save',
          			cancelButtonText: 'Discard Changes'
				})
				.then(()=> {
					self.gotoNew = true;
					self.$emit(self.saveEvent);
					self.saveChanges = false;
				})
				.catch(()=> self.$emit(self.newEvent));
			}
			else{
				self.$emit(self.newEvent);
			}
		},
		handleExit() {
			let self = this;

			if(this.saveChanges){
				this.$confirm('Do you want to save the current changes first?', 'Confirm', {
					distinguishCancelAndClose: true,
					confirmButtonText: 'Save',
          			cancelButtonText: 'Discard Changes'
				})
				.then(()=> {
					self.gotoList = true;
					self.$emit(self.saveEvent);
					self.saveChanges = false;
				})
				.catch(()=> self.$emit(self.exitEvent));
			}
			else{
				self.$emit(self.exitEvent);
			}
		},
		deletePrompt() {
			let self = this;
			this.$confirm('Are you sure you want to delete this record?', 'Confirm Delete', {
				confirmButtonText: 'Delete',
				cancelButtonText: 'Cancel',
				type: 'warning',
				center: true
			})
			.then(()=> self.$emit(self.deleteEvent))
			.catch(()=> {});
		},
		deactivatePrompt() {
			let self = this;
			this.$confirm('Are you sure you want to deactivate this record?', 'Confirm Deactivation', {
				confirmButtonText: 'Deactivate',
				cancelButtonText: 'Cancel',
				type: 'warning',
				center: true
			})
			.then(()=> self.$emit(self.deleteEvent))
			.catch(()=> {});
		},
		deleteSelectedPrompt() {
			let self = this;
			this.$confirm('Are you sure you want to deactivate the selected record(s)?', 'Confirm Deactivations', {
				confirmButtonText: 'Deactivate',
				cancelButtonText: 'Cancel',
				type: 'warning',
				center: true
			})
			.then(_=> self.$emit(self.deleteEvent))
			.catch(_=> {});
		},
		propertyChanged() {
			this.saveChanges = true;
		},
		entitySaved() {
			if(this.gotoNew){
				this.$emit(this.newEvent);
			}
			else if(this.gotoList){
				this.$emit(this.exitEvent);
			}

			this.untrackChanges();
		},
		untrackChanges(){
			this.saveChanges = false;
			this.gotoNew = false;
			this.gotoList = false;
		},
        disableAllDatesBeforeToday (date) {
			return (date <= new Date().setDate(new Date().getDate() - 1));
		},
        disableAllDatesAfterToday (date) {
		var _today = new Date().toISOString().substring(0, 10);
		if(date.toISOString().substring(0, 10) >= _today)
			{return true;}
			else {return false;}
		},
        disableLessThan18Dates(date){
            var curr = new Date();
            var _last18 = new Date(Date.UTC(curr.getUTCFullYear()-18, curr.getUTCMonth(), curr.getUTCDate()));

            if(date.toISOString().substring(0, 10) >= _last18.toISOString().substring(0, 10))
                {return true;}
                else {return false;}
        },
        todaysDate() {
            return new Date().toDateString();
		},
		yesterdaysDate() {
			var date = new Date();
			date.setDate(date.getDate() -1);
			return date.toDateString();
		},
		currentYear() {
			return new Date().getUTCFullYear();
		},
        joinDateTime(date, time) {
            return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            time.getHours(), time.getMinutes(), time.getSeconds()));
        },
        legalAge() {
			const current = new Date();
			const date = `${current.getFullYear()-18}-${("0" + (current.getMonth()+1)).slice(-2)}-${("0" + (current.getDate())).slice(-2)}`;
			return date;

            // var curr = new Date();
            // return new Date(Date.UTC(curr.getUTCFullYear()-18, curr.getUTCMonth(), curr.getUTCDate()));
		},
		startLoader(text){
			this.pageLoading = true;
			this.loadingText = text;
		},
		stopLoader(){
			this.pageLoading = false;
			this.loadingText = 'Loading...';
		},
		groupBy(list, props) {
			if(list && list.length > 0){
				return list.reduce((a, b) => {
					(a[b[props]] = a[b[props]] || []).push(b);
					return a;
				}, {});
			}

			return [];
		},
		getbarChartOptions(xLabel, yLabel) {
			let barChartOptions = {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					xAxes: [{
						stacked: false,
						barPercentage: 0.5,
						categoryPercentage: 0.2,
						scaleLabel: {
							display: xLabel,
							labelString: xLabel,
							fontFamily: "Arial",
							fontColor: "white",
						},
						ticks: {
							beginAtZero: true
						}
					}],
					yAxes: [{
						stacked: false,
						scaleLabel: {
							display: yLabel,
							labelString: yLabel,
							fontFamily: "Arial",
							fontColor: "white",
						},
						ticks: {
							beginAtZero: true,
							stepSize: 1,
							userCallback: ''
						}
					}]
				}
			};

			return barChartOptions;
		},
		donutChartOptions() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				cutoutPercentage: 80
			};
		},
		formatThousands(value, index, values) {
			// Convert the number to a string and splite the string every 3 charaters from the end
			value = value.toString();
			value = value.split(/(?=(?:...)*$)/);

			// Convert the array to a string and format the output
			value = value.join(',');
			// return '€' + value;
			return value;
		},
		formatDateTime(value, index, values) {
			return new Date(value).toLocaleDateString('en-US', {month:'short', day:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit'});
		},
		// formatDate(value, index, values) {
		// 	return new Date(value).toLocaleDateString('en-US', {month:'short', year:'numeric'});
		// },
		formatTime(value, index, values) {
			return new Date(value).toLocaleDateString('en-US', {hour:'2-digit', minute:'2-digit'});
		},
		getSearchModel(page, size, search) {
			return {
				page: page,
				size: size,
				search: search
			};
		}
	},
	mixins: [TablesMixin]
}